import r from'@mui/material/Breadcrumbs';var m=r;export{m as Breadcrumbs};//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map